export const PROJECTS = [
  {
    id: '1',
    title: 'Shopee Clone UI',
    description:
      'A project clone UI shopee. The project was build with HTML, CSS, JavaScript.',
    image: {
      src: 'https://i.imgur.com/vtCGFxw.png',
      placeholderSrc:
        'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzIDIiPjwvc3ZnPg==',
    },
    links: {
      site: 'https://xuanchinh97.github.io/Shopee_clone/',
      repo: 'https://github.com/xuanchinh97/Shopee_clone',
    },
    technologies: [
      '#html',
      '#css',
      '#javascript',
    ],
  },
  {
    id: '2',
    title: 'Play Music',
    description:
      'Play music basic with JavaScript.',
    image: {
      src: 'https://i.imgur.com/ub6qV0P.png',
      placeholderSrc:
        'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzIDIiPjwvc3ZnPg==',
    },
    links: {
      site: 'https://xuanchinh97.github.io/Play_music/',
      repo: 'https://github.com/xuanchinh97/Play_music',
    },
    technologies: [
      '#html',
      '#css',
      '#javascript',
    ],
  },
  {
    id: '3',
    title: 'Todo List',
    description:
      'It is a list manager of tasks you need to complete or things that you want to do',
    image: {
      src: 'https://i.imgur.com/pMLyHuV.png',
      placeholderSrc:
        'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzIDIiPjwvc3ZnPg==',
    },
    links: {
      site: 'https://xuanchinh97.github.io/Todo-list/',
      repo: 'https://github.com/xuanchinh97/Todo-list',
    },
    technologies: [
      '#html',
      '#css',
      '#javascript',
    ],
  },
  {
    id: '4',
    title: 'Xuanchinh Mobile',
    description:
      'Simple website sell smart phone',
    image: {
      src: 'https://i.imgur.com/0VPaHO5.png',
      placeholderSrc:
        'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzIDIiPjwvc3ZnPg==',
    },
    links: {
      site: 'https://xuanchinhmobile.cf/',
      repo: 'https://github.com/xuanchinh97/Do-An-Web-PHP',
    },
    technologies: [
      '#php',
      '#javaScript',
      '#html',
      '#css',
    ],
  },
  {
    id: '5',
    title: 'Tik Tac Toe',
    description:
      'Tic Tac Toe game web version simply using HTML, JS.',
    image: {
      src: 'https://i.imgur.com/D4lIgPV.png',
      placeholderSrc:
        'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzIDIiPjwvc3ZnPg==',
    },
    links: {
      site: 'https://xuanchinhcaro.herokuapp.com/',
      repo: 'https://github.com/xuanchinh97/game-caro-online',
    },
    technologies: [
      '#nodejs',
      '#socket-io',
      '#javaScript',
    ],
  },
  {
    id: '6',
    title: 'Weather App',
    description:
      'A weather app that uses animation to give you an at-a-glance look at the weather.',
    image: {
      src: 'https://i.imgur.com/vv27Y4o.png',
      placeholderSrc:
        'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzIDIiPjwvc3ZnPg==',
    },
    links: {
      site: 'https://xuanchinh97.github.io/weather-app/',
      repo: 'https://github.com/xuanchinh97/weather-app',
    },
    technologies: [
      '#html',
      '#css',
      '#javaScript',
    ],
  },
  {
    id: '7',
    title: 'Facebook Clone UI',
    description:
      'A UI clone of the Facebook app that I created using Bootstrap.',
    image: {
      src: 'https://i.imgur.com/CbBALka.png',
      placeholderSrc:
        'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzIDIiPjwvc3ZnPg==',
    },
    links: {
      site: 'https://xuanchinh97.github.io/facebook-clone/home.html',
      repo: 'https://github.com/xuanchinh97/facebook-clone',
    },
    technologies: [
      '#html',
      '#css',
      '#bootstrap5',
    ],
  },
  {
    id: '8',
    title: 'WordPress News',
    description:
      'Online newspaper site.',
    image: {
      src: 'https://i.imgur.com/QdbMsa4.png',
      placeholderSrc:
        'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzIDIiPjwvc3ZnPg==',
    },
    links: {
      site: 'https://nguoinoitiengvn.cf/',
      repo: '#',
    },
    technologies: [
      '#wordpress',
    ],
  },
];
